import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ROUTE_NAMES: Record<string, string> = {
  "/": "Home",
  "/dashboard": "Dashboard",
  "/stock-research": "Stock Research Lab",
  "/calculators": "Calculators",
  "/real-estate": "Real Estate Planner",
  "/tax-simulator": "Tax Planner",
  "/retirement": "Retirement Planner",
  "/rent-vs-buy": "Rent vs Buy",
  "/debt-killer": "Debt-Free Path",
  "/tools": "Explore Tools",
  "/emi-mentor": "EMI Mentor",
  "/life-stages": "Life Stages",
  "/credit-card-master": "Credit Card Master",
  "/asset-comparison": "Asset Comparison",
  "/profile": "Profile",
};

export function BreadcrumbJsonLd() {
  const { pathname } = useLocation();

  useEffect(() => {
    const id = "breadcrumb-jsonld";
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.id = id;
      el.setAttribute("type", "application/ld+json");
      document.head.appendChild(el);
    }

    const name = ROUTE_NAMES[pathname] || pathname.replace(/^\//, "").replace(/-/g, " ");
    const items = [
      { "@type": "ListItem", position: 1, name: "VittaSathi", item: "https://vittasathi.com" },
    ];
    if (pathname !== "/") {
      items.push({
        "@type": "ListItem",
        position: 2,
        name,
        item: `https://vittasathi.com${pathname}`,
      });
    }

    el.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items,
    });

    return () => {
      el?.remove();
    };
  }, [pathname]);

  return null;
}
